import type { AxleInformationInputsSchema } from '@src/orders/schemas/AxleInformationInputsSchema';
import type * as yup from 'yup';

export const AxleAssembler = {
  toResponse: (
    axle: yup.InferType<typeof AxleInformationInputsSchema>,
    axleId?: string,
  ) => {
    return {
      weight: axle.axleWeight ?? undefined,
      capacity: axle.axleCapacity ?? undefined,
      width: axle.axleWidth ?? undefined,
      tireCount: axle.tireCount ?? undefined,
      tireRating: axle.tireRating ?? undefined,
      tireSize: axle.tireSize ?? undefined,
      suspensionType: axle.suspensionType ?? undefined,
      group: axle.axleGroup ?? undefined,
      isSteeringAxle: axle.isSteeringAxle ?? undefined,
      spacing: axle.axleSpacing ?? undefined,
      type: axle.axleType ?? undefined,
      id: axleId,
    };
  },
};
